import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "../ui/button"

const MarketingBanner = () => {
  const navigate = useNavigate()
  const handleRegisterClick = () => {
    navigate("/5daybusinessbootcamp")
    navigate("/5daybusinessbootcamp")
  }

  return (
    <section
      className="relative py-4 px-4 flex justify-center text-center"
      style={{
        background: "linear-gradient(90deg, #FFEC8E 0%, #C47070 100%)",
      }}
    >
      <div className="flex flex-wrap items-center justify-center gap-3 leading-snug max-w-[1100px]">
        <span className="italic">
          Build your coaching business with calm, clarity, and integrity. Save
          your seat in our next Business Bootcamp.
        </span>
        <Button variant="black" className="" onClick={handleRegisterClick}>
          JOIN NOW
        </Button>
      </div>
    </section>
  )
}

export default MarketingBanner
